import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useSectionType } from '../../../../sections/SectionTypeContext.tsx';

export interface ILayoutHideConfigInputProps {}

export function LayoutHideConfigInput(props: ILayoutHideConfigInputProps) {
  const { sectionType } = useSectionType();

  if (sectionType === 'DOCUMENT') return null;

  return (
    <FormItem
      name="layout.hide"
      label={null}
      layout={{ removeLabelSpace: true }}
    >
      <CheckboxInput name="layout.hide" defaultChecked={false}>
        Nascondi elemento in compilazione
      </CheckboxInput>
    </FormItem>
  );
}
